import React from 'react';
import { Descriptions, Typography } from 'antd';
import Markdown from 'react-markdown';
import { replaceBrWithNewline,formatSize } from '../../utils/utils';
import { locale } from '../../api/config';
import styles from './index.module.less';

const { Paragraph } = Typography;

const FileDetail = ({ data }) => {
  const { file_name, version, products, desc, checksum, release_note } = data;
  return (
    <div className={styles.file_detail}>
      <Descriptions labelStyle={{ fontWeight: 550 }}>
        <Descriptions.Item label={<strong>File Name</strong>}>
          {file_name || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<strong>Version</strong>}>
          {version || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<strong>Size</strong>}>
          {formatSize(data.size) || '-'}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        column={1}
        labelStyle={{ fontWeight: 550 }}
        layout='vertical'
      >
        <Descriptions.Item
          label={<strong>Products</strong>}
          contentStyle={{ display: 'block' }}
        >
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: 'more',
            }}
          >
            {products.join(' , ') || '-'}
          </Paragraph>
        </Descriptions.Item>
        <Descriptions.Item label={<strong>Description</strong>}>
          {desc[locale] || '-'}
        </Descriptions.Item>
        <Descriptions.Item label={<strong>Release Notes</strong>}>
          <div className={styles.release_note}>
            <Markdown>{replaceBrWithNewline(release_note[locale])}</Markdown>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label='Checksum'>
          {checksum || '-'}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default FileDetail;
